import { Block, Inline } from '@contentful/rich-text-types';
import type { Sys } from 'src/types/contentful-sdk-compat';
import { Column, Stack } from 'src/components-v2/Layout';
import { RichTextSwitch } from 'src/containers';

interface LeftColumnProps {
  sys: Sys;
  fields: {
    body: Block | Inline;
  };
}

export const LeftColumn: React.FC<LeftColumnProps> = ({ sys, fields }) => {
  return (
    <Column xs={24} md={12} lg={8} lgOffset={2}>
      <Stack
        direction={{ xs: 'row', md: 'column' }}
        gap={{
          md: 5,
        }}
        sx={{
          height: '100%',
        }}
      >
        <Stack
          gap={{
            xs: 1,
            md: 3,
          }}
          sx={{
            img: {
              mt: '40px',
              display: { xs: 'none', md: 'inline-block' },
            },
            '& p:nth-last-of-type(1):empty': {
              display: 'none',
            },
          }}
        >
          <RichTextSwitch
            sys={sys}
            content={fields.body}
            nodes={{
              h2: { variant: 'h2', component: 'h2', fieldId: 'body' },
              p: {
                variant: 'p',
                component: 'p',
                fieldId: 'body',
                // 🤮
                sx: { fontSize: { xs: '1.8rem', md: '2.0rem' } },
              },
              asset: {
                // We intentionally don't pass many values here because any aspect ratio can be used
                // even passing the querystring should be reconsidered because it's now tightly coupled to the spec
                queryString: { xl: '?fm=webp&q=60' },
              },
            }}
          />
        </Stack>
      </Stack>
    </Column>
  );
};
